import type { TFunction } from 'i18next';

import { DEFAULT_RECLAIM_POLICY, getReclaimPolicyDescriptions } from './constants';
import type { ReclaimPolicyOptionItem } from './types';

export function mapReclaimPolicyItems(values: string[]): ReclaimPolicyOptionItem[] {
  if (!values?.length) return [];
  return values.map((value) => ({ label: value, value }));
}

/**
 * SKU 创建 / 下单注入 `resourceEditMode`；直建不传。
 * 有 resourceEditMode 时回收策略锁定为 Delete，仅直建可改。
 */
export function isReclaimPolicyLocked(resourceEditMode?: string | null): boolean {
  return Boolean(resourceEditMode);
}

/** 锁定场景强制 Delete；否则保留已有值并回退默认 Delete */
export function resolveReclaimPolicyValue(value?: string | null, locked?: boolean): string {
  if (locked) return DEFAULT_RECLAIM_POLICY;
  const trimmed = String(value ?? '').trim();
  return trimmed || DEFAULT_RECLAIM_POLICY;
}

/** API 不可用时的静态回收策略选项（value/label 与 API 一致） */
export function getStaticReclaimPolicyOptions(): ReclaimPolicyOptionItem[] {
  return [
    { value: 'Retain', label: 'Retain' },
    { value: 'Delete', label: 'Delete' },
  ];
}

/** 为选项附加说明文案（API / 静态共用） */
export function attachReclaimPolicyDescriptions(options: ReclaimPolicyOptionItem[], t: TFunction): ReclaimPolicyOptionItem[] {
  const descriptions = getReclaimPolicyDescriptions(t);
  return options.map((opt) => ({
    ...opt,
    description: descriptions[opt.value] ?? opt.description,
  }));
}

/** Select options.extra：下拉 label 为 JSX 时写入 optionMeta 展示名 */
export function buildReclaimPolicySelectExtra(opt: ReclaimPolicyOptionItem): Record<string, string | undefined> {
  return {
    name: opt.label,
    label: opt.label,
    value: opt.value,
    description: opt.description,
  };
}
